import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  ContainmentType,
  EVENT_CLICK,
  EVENT_CONNECTION_ABORT,
  EVENT_CONNECTION_DRAG,
  newInstance,
  ready,
  AnchorLocations,
  AnchorSpec,
  Connection,
  ConnectionDetachedParams,
  ConnectionMovedParams,
  DotEndpoint,
  EVENT_CONNECTION_DETACHED,
  EVENT_CONNECTION_MOVED,
  LabelOverlay,
  FlowchartConnector,
  ENDPOINT,
  BrowserJsPlumbInstance,
  EVENT_DRAG_STOP,
  EVENT_CONNECTION_DBL_CLICK,
} from "@jsplumb/browser-ui";
import {
  FlowchartJSON,
  FlowConnection,
  FlowNode,
} from "../../../shared/modelClasses/modelClasses";
import { CbService } from "src/app/services/contentbuilder/contentbuilder.service";
import { NgxSpinnerService } from "ngx-spinner";
import { ClientService } from "src/app/services/clients/client.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AudienceBuilderService } from "src/app/services/segmentation/audience-builder.service";
import { FormBuilder, FormGroup, FormArray, Validators } from "@angular/forms";
import { Router,ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import {
  JourneyBuilderTableStateService,
  UsersFilters,
} from "../journey-list/journey-list-table.service";
import {
  debounceTime,
  distinctUntilChanged,
  map,
  pairwise,
  skip,
  startWith,
  take,
} from "rxjs/operators";
import { Subscription } from "rxjs";
import { TableState } from "src/app/services/base-table-state.service";
import { MasterService } from "src/app/services/master/master.service";
import { WorkingCompanyService } from 'src/app/services/working-company/working-company.service';

@Component({
  selector: "app-journey-builder",
  templateUrl: "./journey-builder.component.html",
  styleUrls: ["./journey-builder.component.scss"],
})
export class JourneyBuilderComponent implements OnInit {
  @ViewChild("routeConditionModal") routeConditionModal: HTMLElement;
  @ViewChild("popupTypeSelect") popupTypeSelect!: ElementRef<HTMLSelectElement>;
  isOpen: boolean = false;
  isMobile: boolean = false;

  nodeForm!: FormGroup;
  journeyflowForm: FormGroup;
  // dropdown data
  actions = [
    { id: 1, name: "Send Email", type: "email" },
    { id: 2, name: "Send SMS", type: "sms" },
  ];
  availableFields = [
    {
      id: "f1",
      name: "First Name",
      table_name: "",
      table_field_operator_list: [],
      table_field_option_values: [],
      table_field_type: "",
      label: "",
      desc: "",
    },
  ];
  selectedFieldDesc = "";
  availableOperators = [];

  // state values
  modalTitle = "Send Email";
  modalLabel = "";
  routeOption = "";
  actionType = "email";
  isEditMode = false;
  selectedField: any = {};
  selectedFieldValueList: any = [];
  selectedFieldValueType: any = "";
  actionsList: any = [];
  conditionsList: any = [];
  showNewRouteOption: boolean = false;
  newRouteCondition = null;
  // conditionValue = null;
  actionValue = null;
  activeButton = "immediately";
  executionData = { type: "", value: "1" };

  disabled = false;
  companyID = 0;
  journeyID: number | null = null;
  domainID: number | null = null;
  domainData: any[] = [];
  journeyTypeObj = [];
  getCompanyobj = [];
  themeObj:any = [];
  journeyBuilderSelectedThemeID: any;
  journeyList: any = [];
  startFlow: boolean = false;
  journeyTypeTheme = [];
  submitted: boolean = false;
  editJourneyId: any;

  instance!: BrowserJsPlumbInstance;

  editNodeId: number | null = null;
  editLabel: string = "";
  nextNodeId: number = 0;
  currentUser: any;
  popup: {
    visible: boolean;
    top: number;
    left: number;
    items: {
      title: string;
      description: string;
      type: string;
      color: string;
    }[];
    dropdownOptions: string[];
    selectedOption: string;
    nodeId: number | null;
    origin: string;
    mode: "cards" | "dropdown";
  } = {
    visible: false,
    top: 0,
    left: 0,
    items: [],
    dropdownOptions: [],
    selectedOption: "",
    nodeId: null,
    origin: "",
    mode: "cards",
  };
  popupDropdownSelectedType: string = "";
  popupSelectedOptionId: number | null = null;

  starterJson: any = [];

  starterConnections: any = [];

  nodes: any = [];
  connections: any = [];

  // this is the paint style for the connecting lines..
  connectorPaintStyle = {
    strokeWidth: 3,
    stroke: "#61B7CF",
    joinstyle: "round",
    outlineStroke: "white",
    outlineWidth: 3,
  };
  // .. and this is the hover style.
  connectorHoverStyle = {
    strokeWidth: 3,
    stroke: "#216477",
    outlineWidth: 5,
    outlineStroke: "white",
  };
  endpointHoverStyle = {
    fill: "#216477",
    stroke: "#216477",
  };
  // the definition of source endpoints (the small blue ones)
  sourceEndpoint = {
    endpoint: DotEndpoint.type,
    paintStyle: {
      stroke: "#7AB02C",
      fill: "#7AB02C",
      radius: 7,
      strokeWidth: 3,
    },
    source: true,
    maxConnections: -1,
    connector: {
      type: FlowchartConnector.type,
      options: {
        stub: [10, 10],
        gap: 7,
        cornerRadius: 20,
        alwaysRespectStubs: true,
      },
    },
    connectorStyle: this.connectorPaintStyle,
    hoverPaintStyle: this.endpointHoverStyle,
    connectorHoverStyle: this.connectorHoverStyle,
    overlays: [
      {
        type: "Label",
        options: {
          location: [0.5, 0.5],
          label: "",
          cssClass: "endpointSourceLabel",
          visible: true,
        },
      },
    ],
  };
  // the definition of target endpoints (will appear when the user drags a connection)
  targetEndpoint = {
    endpoint: DotEndpoint.type,
    paintStyle: { stroke: "#7AB02C", fill: "#7AB02C", radius: 7, strokeWidth: 3 },
    hoverPaintStyle: this.endpointHoverStyle,
    maxConnections: -1,
    target: true,
    overlays: [
      {
        type: "Label",
        options: {
          location: [0.5, -0.5],
          label: "",
          cssClass: "endpointTargetLabel",
          visible: true,
        },
      },
    ],
  };

  journeyBuilderSelectedThemeCategoryID: any = 0;
  getSocialPostMediaTypeRows: any = [];

  private _initJsPlumbWithFlowData() {
    this.instance.bind(EVENT_DRAG_STOP, (evt) => {
      const el = evt.el as HTMLElement;
      if (!el) return;

      const nodeId = Number(el.id.replace("flowchartWindow", ""));
      if (Number.isNaN(nodeId)) return;

      const left = Math.round(el.offsetLeft);
      const top = Math.round(el.offsetTop);

      this.updateNodePosition(nodeId, left, top);

    });

    let customLabel: any = [];

    this.instance.batch(() => {
      this.nodes.forEach((node) => {
        if (node.node_form_data?.executionData) {
          let value = node.node_form_data?.executionData.value;
          let type = node.node_form_data?.executionData.type;
          if (type === "dateTime") {
            customLabel.push({
              id: node.id,
              label: "wait until " + `${value}`,
            });
          } else {
            const plural = value === 1 ? type.replace(/s$/, "") : type;
            const executionLabel = node.node_form_data?.activeButton === "await-time-period" ? "Wait" : "Wait Until Time";
            customLabel.push({
              id: node.id,
              label: `${executionLabel} (${value}  ${plural})`,
            });
          }
        }
        const el = document.getElementById("flowchartWindow" + node.id);

        if (el) {
          el.style.left = Math.round(node.left) + "px";
          el.style.top = Math.round(node.top) + "px";
        }

        this._addEndpoints(
          "Window" + node.id.toString(),
          node.sourceAnchors,
          node.targetAnchors,
        );
        if (el) {
          this.instance.manage(el); // ✅ REQUIRED
        }
      });

      this.connections.forEach((conn: any) => {
        const fromUUID = `Window${conn.sourceId}${conn.sourceAnchor}`;
        const toUUID = `Window${conn.targetId}Top`;
        const connectionOptions: any = {
          uuids: [fromUUID, toUUID],
        };
        const getMatchLabel = customLabel.filter(
          (obj) => obj.id === Number(conn.targetId),
        );

        if (getMatchLabel.length > 0) {
          connectionOptions.overlays = [
            {
              type: "Label",
              options: {
                label: `${getMatchLabel[0].label}`,
                location: 0.5,
                id: `overlay-${getMatchLabel[0].id}`,
                cssClass: "custom-overlay",
              },
            },
          ];
        }

        this.instance.connect(connectionOptions);
      });
    });

    this.instance.bind('connection', (info: any) => {      
      const sourceId = info.sourceId.replace('flowchartWindow', '');
      const targetId = info.targetId.replace('flowchartWindow', '');
      const sourceAnchor = info.sourceEndpoint._anchor.type;
      const targetAnchor = AnchorLocations.Top;

      const alreadyExists = this.connections.some((c: any) =>
        c.sourceId === sourceId &&
        c.targetId === targetId
      );

      if (alreadyExists) {
        return;
      }

      this.connections.push({
        sourceId,
        sourceAnchor,
        targetId,
        toAnchor: targetAnchor,
        ...(sourceAnchor === 'BottomLeft' ? { branch: 'Yes' } : { branch: 'No' })
      });

      const node = this.nodes.find((n: any) => n.id == targetId);
      const allConnections = this.instance.getConnections() as unknown as Connection[];
      const connections = (allConnections || []).filter((conn) => conn.targetId === "flowchartWindow" + node.id.toString(),);
      this.updateNodeOverlayLabel(node, connections);

    })

    this.instance.bind(EVENT_CONNECTION_DETACHED, (info: any) => {
      const sourceId = info.sourceId.replace('flowchartWindow', '');
      const targetId = info.targetId.replace('flowchartWindow', '');

      const exists = this.connections.some((c: any) =>
        c.sourceId === sourceId &&
        c.targetId === targetId
      );

      if (!exists) {
        return;
      }

      this.connections = this.connections.filter(
        (c: any) => !(c.sourceId === sourceId && c.targetId === targetId)
      );
    });

    this.instance.bind(EVENT_CONNECTION_DBL_CLICK, (info: any) => {
      this.instance.deleteConnection(info);
    });
  }

  private sub = new Subscription();
  // private isDefaultFilters(filters: UsersFilters): boolean {
  //   return (
  //     filters.companyID === null
  //   );
  // }
    private isDefaultFilters(filters: UsersFilters): boolean {
    return (
      filters.companyID === null &&
      filters.domainID === null &&
      filters.journeyID === null
    );
  }

  hasProductObj: any = [{name: 'Yes', value: true},{name: 'No', value: false}];
  hasProductVal: boolean = false;

  constructor(
    private clientService: ClientService,
    private ngxSpinnerService: NgxSpinnerService,
    private cb: CbService,
    private ngbModal: NgbModal,
    private audienceBuilderService: AudienceBuilderService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router, 
    private toastrService: ToastrService,
    public tableState: JourneyBuilderTableStateService,
    public master: MasterService,
    private workingCompany: WorkingCompanyService
  ) {
    this.journeyflowForm = this.fb.group({
      journeyflowName: ["", Validators.required],
      company: [this.companyID, Validators.required],
      domainName: [0],
      journeyTypeID: [0, Validators.required],
      themeID: ["", Validators.required],
    });
  }

  goBack() {
  this.router.navigate(['/corporate/journey-list'], {
    queryParams: this.route.snapshot.queryParams
  });
}

  private handleInitialLoad(state: TableState<UsersFilters>) {
    if (this.isDefaultFilters(state.filters)) {
      return;
    }

    const filters = state.filters;
   
    
    this.companyID = filters.companyID;
    this.domainID = filters.domainID;
    this.journeyID = filters.journeyID;
    // this.getAllCompanyJourney();
    // this.themesID = this.journeyID ? filters.themesID : [];
    // this.page = state.pageIndex;
    // this.limit = state.pageSize;

    if (this.companyID) {
      this.getAllCompanyJourney();
      // this.getBusinessDomain();
    }

    
    console.log("filters.domainID", filters.domainID);
    if (!filters.domainID || filters.domainID === 0) {
      console.log("filters.domainID in", filters.domainID);
      this.journeyflowForm.patchValue({
        domainName: 0,
      });
    }
    if (filters.domainID != null) {
      this.journeyflowForm.patchValue({
        domainName: Number(filters.domainID),
      });
    }
    if (filters.journeyID != null) {
      this.journeyflowForm.patchValue({
        journeyTypeID: Number(filters.journeyID),
      });
      this.getThemeList();
    }
    if (filters.journeyID === 0 || filters.journeyID === null || !filters.journeyID) {
      this.journeyflowForm.patchValue({
        journeyTypeID: 0,
      });
      this.getThemeList();
    }
    // if (this.companyID) this.getCompanyJourneyType();
    // if (this.journeyID) this.getThemeList();
    // if (state.searchTerm != '') this.searchTemplateText = state.searchTerm;

    if (state.pageIndex !== 1 || state.pageSize !== 10) {
      // this.page = state.pageIndex;
      // this.limit = state.pageSize;
    }
    //  this.getJourneyListData(this.companyID)
    // this.getEmailTemplateData(this.companyID, 'initial load');
  }

  private handleStateChanges(
    prevState: TableState<UsersFilters>,
    currState: TableState<UsersFilters>,
  ) {
    const prevFilters = prevState.filters;
    const currFilters = currState.filters;

    if (this.isDefaultFilters(currState.filters)) {
      return;
    }
    // Company Changed
    if (prevFilters.companyID !== currFilters.companyID) {
      this.companyID = currFilters.companyID;
      this.getBusinessDomain();
      // this.getCompanyJourneyType();
      // this.getJourneyListData(this.companyID)
    }

    // // Domain Changed
    // if (prevFilters.domainID !== currFilters.domainID) {
    //   this.domainID = currFilters.domainID;
    //   this.journeyflowForm.patchValue({ domainName: this.domainID });
    // }

    // Pagination Changed
    if (
      prevState.pageIndex !== currState.pageIndex ||
      prevState.pageSize !== currState.pageSize
    ) {
      // this.page = currState.pageIndex;
      // this.limit = currState.pageSize;
    }
    // this.getEmailTemplateData(this.companyID, 'state change');
  }

  async ngOnInit() {
    this.checkScreen();
    await this.getCompany();
    // Handle state changes with pairwise to get previous and current state
    this.sub.add(
      this.tableState.state$
        .pipe(pairwise())
        .subscribe(([prev, curr]) => this.handleStateChanges(prev, curr)),
    );
    // Handle FIRST load separately
    this.sub.add(
      this.tableState.state$
        .pipe(take(1))
        .subscribe((state) => this.handleInitialLoad(state)),
    );
    this.editJourneyId = Number(this.route.snapshot.queryParamMap.get("jid"));
    if(this.editJourneyId){
      this.companyID = Number(this.route.snapshot.queryParamMap.get("cid"));
    }
    if (this.companyID) {
      this.journeyflowForm.patchValue({
        company: this.companyID,
        domainName: this.domainID,
      });
      // prepopulate domains for this company
      this.getBusinessDomain();
    }
    // this.getJourneyList();
    if (this.editJourneyId) {
      this.getJourneyBuilderDataById(this.companyID, this.editJourneyId);
    }

    this.nodeForm = this.fb.group({
      name: ["", Validators.required],
      actionValue: [null],
      socialPostMediaType: [null],
      toSendType: ["transactional"],
      executionData: this.fb.group({
        value: [""],
        type: [""],
      }),
      condition: this.fb.group({
        field: [null],
        operator: [null],
        value: [null],
      }),
    });

    this.nodeForm.get("condition.field")?.valueChanges.subscribe((fieldId) => {
      // Reset value whenever field changes
      this.nodeForm
        .get("condition.operator")
        ?.reset(null, { emitEvent: false });
      this.nodeForm.get("condition.value")?.reset(null, { emitEvent: false });

      this.onSelectConditionField(fieldId);
    });

    this.nodeForm
      .get("condition.operator")
      ?.valueChanges.subscribe((fieldId) => {
        // Reset value whenever operator changes
        this.nodeForm.get("condition.value")?.reset(null, { emitEvent: false });

        this.onSelectConditionFieldOperator(this.selectedField);
      });

    if (this.editJourneyId) {
      this.journeyflowForm.get('company')?.disable();
    } else {
      this.journeyflowForm.get('company')?.enable();
    }
  }

  getJourneyBuilderDataById(companyID: number, journey_id: number) {
    this.ngxSpinnerService.show();
    this.clientService
      .getJourneyBuilderDataById(companyID, journey_id)
      .subscribe(
        (res) => {
          const data = res?.data;
          if (res.status) {
            const builderDataJSON = JSON.parse(data.cjb_json);
            const jid = data?.journey_id;
            const tid = data?.theme_id;
            this.journeyBuilderSelectedThemeID = tid;
            this.hasProductVal = data?.is_product ? data?.is_product : false;
            this.journeyBuilderSelectedThemeCategoryID = data?.theme_category_id;
            this.journeyflowForm.patchValue({
              journeyTypeID: jid,
              themeID: tid,
              journeyflowName: data.cjb_name,
            });
            if (jid) {
              this.getThemeList();
            }
            this.loadDataToBuilder(builderDataJSON.flowchart);
            this.ngxSpinnerService.hide();
          } else {
            this.ngxSpinnerService.hide();
          }
        },
        (error) => {
          console.log(error);
          this.ngxSpinnerService.hide();
          this.toastrService.error(
            "Something went wrong while fetching journey builder data.",
          );
        },
      );
  }

  loadDataToBuilder(data: any) {
    this.starterJson = data.nodes;
    this.starterConnections = data.connections;
    this.nodes = [...this.starterJson];
    this.connections = this.starterConnections;
    this.onUploadJson();
    this.getActions();
    this.getConditions();
  }

  setExecutionDataValidators(): void {
    const executionDataGroup = this.nodeForm.get("executionData") as FormGroup;

    if (!executionDataGroup) return;

    const valueControl = executionDataGroup.get("value");
    const typeControl = executionDataGroup.get("type");

    if (!valueControl || !typeControl) return;

    // Reset validators before applying new ones
    valueControl.clearValidators();
    typeControl.clearValidators();

    if (this.activeButton === "await-time-period" || this.activeButton === "till-time-period") {
      // Require both value and type
      valueControl.setValidators([Validators.required, Validators.min(1)]);
      typeControl.setValidators([Validators.required]);
    } else if (this.activeButton === "date-time") {
      // Require only value
      valueControl.setValidators([Validators.required]);

      // Auto-fill type with "dateTime"
      typeControl.setValue("dateTime", { emitEvent: false });
    }

    // Recalculate validity
    valueControl.updateValueAndValidity();
    typeControl.updateValueAndValidity();
  }

  async getCompany() {
    let self = this;
    const data = await this.clientService.getBUCompanies().toPromise();
    try {
      1;
      self.getCompanyobj = data.data;
      self.workingCompany.applyToHost(self, (id) => { self.getJourneyList(); });

       this.getCompanyobj = this.getCompanyobj.sort((a, b) => {
          return a.customer_company_name.localeCompare(b.customer_company_name);
        });
      // if (!this.editJourneyId) {
      //   this.companyID = self.getCompanyobj[0].customer_id;
      //   this.journeyflowForm.patchValue({
      //     company: this.companyID,
      //   });
      // }
    } catch (err) {
      throw err;
    }
  }

  getAllCompanyJourney() {
   if (this.companyID) {
      let self = this;
      this.ngxSpinnerService.show();
      this.clientService.getAllJourney(this.companyID).subscribe(
        (data) => {
          if (data.status) {
            self.journeyTypeObj = data?.rows.map((item) => ({
              journey_id: item.journey_id,
              journey_name: item.journey_name,
            }));
            this.ngxSpinnerService.hide();
          } else {
            self.journeyTypeObj = [];
            this.ngxSpinnerService.hide();
          }
        },
        (error) => {
          console.log(error);
          this.ngxSpinnerService.hide();
        },
      );
      this.tableState.updateFilters({ companyID: this.companyID, domainID: this.domainID });
    } else {
      this.journeyTypeObj = [];
      this.ngxSpinnerService.hide();
    }
  }
  getJourneyList() {
    this.companyID = this.journeyflowForm.get("company").value;
    // clear any previously selected domain when company changes
    this.domainID = 0;
    this.journeyTypeObj = [];
    this.journeyList = [];
    this.tableState.updateFilters({ companyID: this.companyID, domainID: null, journeyID: null });
    this.journeyflowForm.patchValue({ comoany: this.companyID,domainName: 0 ,journeyTypeID: 0, themeID: ""});

    this.journeyTypeObj = [];
    this.journeyList = [];
    this.getAllCompanyJourney();
    this.getBusinessDomain();
  }

  onJourneyChange() {
    const value = Number(this.journeyflowForm.get("journeyTypeID").value);
    this.tableState.updateFilters({ journeyID: value });
    this.journeyflowForm.patchValue({themeID: "",});
    this.getThemeList();
  }

  onDomainChange() {
   const value = Number(this.journeyflowForm.get("domainName").value);
    this.domainID = value;
    this.journeyBuilderSelectedThemeCategoryID = this.domainID;
    this.journeyID = null;
    this.tableState.updateFilters({ domainID: value, journeyID: null });
    // when domain changes we might want to refetch themes in case domain affects them
    this.journeyflowForm.patchValue({ domainName: value ,journeyTypeID: 0, themeID: ''});
  }
    getBusinessDomain() {
    let self = this;
    if (!this.companyID) return;
    this.master.getBusinessDomain(100, 0, this.companyID).subscribe(
      (data) => {
        self.domainData = data?.data?.rows || [];
        // reapply selected domain after options arrive
        if (this.domainID != null && this.domainID !== 0) {
          this.journeyflowForm.patchValue({ domainName: this.domainID,  });
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getThemeList() {

    this.themeObj = [];
    const jid = this.journeyflowForm.get("journeyTypeID").value;
    const did = this.journeyflowForm.get("domainName").value;
    this.ngxSpinnerService.show();
    this.clientService.getAllThemeWithJourney(this.companyID, jid, did).subscribe(
      (data) => {
        if (data.status && data.rows) {

          this.themeObj = data.rows;
          setTimeout(() => {
            this.journeyflowForm.get('themeID')?.setValue(this.journeyBuilderSelectedThemeID);
          },200);
          this.ngxSpinnerService.hide();
        } else {
          this.themeObj = [];
          this.ngxSpinnerService.hide();
        }
      },
      (error) => {
        this.themeObj = [];
        console.log(error);
        this.ngxSpinnerService.hide();
      },
    );
  }

  getActions() {
    this.actions = [];
    this.clientService.getAllActions(this.companyID).subscribe(
      (data) => {
        if (data.status) {
          this.actionsList = data?.rows.map((item) => ({
            id: item.id,
            name: item.media_name,
            type: item.message_type,
            label: item.media_label
          }));
        }
      },
      (error) => {
        console.log(error);
      },
    );
  }

  getConditions() {
    this.conditionsList = [];
    this.ngxSpinnerService.show();
    this.clientService.getAllEntity(this.companyID).subscribe(
      (data) => {
        if (data.status) {
          this.conditionsList = data?.data.map((item) => ({
            id: item.entity_id,
            name: item.entity_name,
            label: item.table_label,
            desc: item.table_desc,
          }));
        }
        this.ngxSpinnerService.hide();
      },
      (error) => {
        console.log(error);
        this.ngxSpinnerService.hide();
      },
    );
  }

  async getConditionFieldsByID(id: any): Promise<any[]> {
    this.ngxSpinnerService.show();
    try {
      const data: any = await this.clientService
        .getAllEntityFieldById(this.companyID, id)
        .toPromise();
      if (data?.status && Array.isArray(data?.data)) {
        return data.data[0].attributeList.map((item: any) => ({
          id: item.field_id,
          name: item.field_name,
          table_name: item.table_name,
          table_field_operator_list: item.table_field_operator,
          table_field_option_values: item.table_field_option_value,
          table_field_type: item.table_field_type,
          label: item.table_label,
          desc: item.table_desc,
        }));
      }
      return [];
    } catch (error) {
      console.error(error);
      return [];
    } finally {
      this.ngxSpinnerService.hide();
    }
  }

  async getAllTemplate(type: string) {
    this.actions = [];
    this.ngxSpinnerService.show();
    try {
      // const data: any = await this.clientService.getAllTemplate(this.companyID, type).toPromise();
      //   if (data.status) {
      //     this.actions = data?.data?.rows.map((item) => ({
      //       id: item.id,
      //       name: item.template_name,
      //       type: item.template_type,
      //       html: item.template_html,
      //     }));
      //   }

      const data: any = await this.clientService
        .getAllTemplate(this.companyID, type, this.journeyBuilderSelectedThemeCategoryID )
        .toPromise();
      if (data.status) {
        this.actions = data?.data?.rows.map((item) => ({
          id: item.message_id,
          name: item.post_name,
          type: item.message_type,
        }));
      }
      this.ngxSpinnerService.hide();
    } catch (error) {
      console.log(error);
      this.ngxSpinnerService.hide();
    }
  }

  async getEmailTemplateLists(type: string) {
    this.actions = [];
    const tid = this.journeyflowForm.get("themeID").value;
    const jid = this.journeyflowForm.get("journeyTypeID").value;
    this.ngxSpinnerService.show();
    try {
      const data: any = await this.clientService
        .getTemplateByThemeJourneyId(this.companyID, tid, jid)
        .toPromise();
      if (data.status) {
        this.actions = data?.data?.rows.map((item) => ({
          id: item.id,
          name: item.template_name,
          type: item.template_type,
          html: item.template_html,
        }));
      }
      this.ngxSpinnerService.hide();
    } catch (error) {
      console.log(error);
      this.ngxSpinnerService.hide();
    }

    // this.clientService.getAllThemeJourney(this.companyID, tid).subscribe(
    //   (data) => {
    //     if (data.status) {
    //       console.log(
    //         "getAllThemeJourneygetAllThemeJourneygetAllThemeJourney",
    //         data,
    //       );
    //       this.actions = data?.rows.map((item) => ({
    //         id: item.journeyid,
    //         name: item.journey_name,
    //         type: type,
    //       }));
    //     }
    //     this.ngxSpinnerService.hide();
    //   },
    //   (error) => {
    //     console.log(error);
    //     this.ngxSpinnerService.hide();
    //   },
    // );
  }

  async getSocialPostTemplateList(type: string) {
    this.actions = [];
    this.ngxSpinnerService.show();
    const mediaType = this.nodeForm.get("socialPostMediaType")!.value ;

    try {
      const data: any = await this.clientService.getSocailPostTemplateLists(this.companyID, this.journeyBuilderSelectedThemeCategoryID, mediaType).toPromise();
      if (data.status) {        
        this.actions = data?.data?.rows.map((item: any) => ({
          id: item.post_id,
          name: item.post_name,
          type: item?.message_type,
        }));
      }
      this.ngxSpinnerService.hide();
    } catch (error) {
      console.log(error);
      this.ngxSpinnerService.hide();
    }
  }

  getSocialPostMediaTypeList(){
    this.getSocialPostMediaTypeRows = [];
    this.clientService.getSocialPostMediaTypeList(this.companyID).subscribe({
      next:(data:any)=>{
        if(data.status){
          this.getSocialPostMediaTypeRows = data?.data || [];
        }
      }, error: (err)=>{
        console.log(err);
      }
    });
  }

  filterSelectedTemplateFromTemplateList(id) {
    return this.actions.filter((obj) => obj.id === id)[0] || null;
  }

  onStart() {
    this.nodes = [];
    this.connections = [];
    this.onUploadJson();
    this.getActions();
    this.getConditions();
    // this.startFlow=true;
    setTimeout(() => {
      this.popup.visible = true;
      this.popup.top = 150;
      this.popup.items = [
        // {
        //   title: "Action",
        //   description:
        //     "An action is something executed by CRM (e.g. send an email).",
        //   type: "action",
        //   color: "#02ad88",
        // },
        {
          title: "Condition",
          description:
            "A condition is based on known profile field values or submitted form data.",
          type: "condition",
          color: "#f86b4f",
        },
      ];
      this.popup.mode = "cards";
      this.popup.selectedOption = "";
      // this.showDropdown('action');
    }, 100);
  }

  onReset() {
    if (this.instance) {
      // Delete all connections
      this.instance.deleteEveryConnection();

      // Delete all endpoints
      // this.instance.deleteEveryEndpoint();

      // Remove all DOM nodes manually (if needed)
      this.nodes.forEach((node) => {
        const el = document.getElementById(`Window${node.id}`);
        if (el) {
          el.remove();
        }
      });

      // Optionally destroy instance (if you plan to reinit it later)
      this.instance.reset();
    }

    // Reset state variables
    this.nodes = [];
    this.connections = [];
    // this.nextNodeId = 1;
    this.startFlow = false; // hide canvas container if using *ngIf

    if (this.nodes.length === 0) {
      this.onStart();
    }
  }

  onUploadJson() {

    this.startFlow = true;
    // Let Angular render the canvas first
    setTimeout(() => {
      const waitForCanvas = () => {
        const canvas = document.getElementById("canvas");
        if (!canvas) {
          setTimeout(waitForCanvas, 50); // check again after 50ms
          return;
        }

        const width = canvas.clientWidth;
        this.popup.left = width / 2 - 227;

        // this.nextNodeId = this.nodes.length + 1;
        // Now canvas exists
        this.instance = newInstance({
          container: canvas,
          dragOptions: {
            cursor: "pointer",
            zIndex: 2000,
            grid: { w: 1, h: 1 },
            containment: ContainmentType.notNegative,
          },
          connectionOverlays: [
            {
              type: "Arrow",
              options: {
                location: 1,
                visible: true,
                width: 11,
                length: 11,
                id: "ARROW",
                events: {
                  click: function () {
                  },
                },
              },
            },
          ],
        });

        // now load chart into instance
        this._initJsPlumbWithFlowData();
      };

      waitForCanvas();
    }, 0);
  }

  _addEndpoints(
    toId: string,
    sourceAnchors: Array<AnchorSpec>,
    targetAnchors: Array<AnchorSpec>,
  ) {
    for (const element of sourceAnchors) {
      const sourceUUID = toId + element;
      this.instance.addEndpoint(
        document.getElementById("flowchart" + toId) as HTMLElement,
        this.sourceEndpoint,
        {
          anchor: element,
          uuid: sourceUUID,
        },
      );
    }
    for (const element of targetAnchors) {
      const targetUUID = toId + element;
      this.instance.addEndpoint(
        document.getElementById("flowchart" + toId) as HTMLElement,
        this.targetEndpoint,
        { anchor: element, uuid: targetUUID },
      );
    }
  }

  showDropdown(type: string) {
    this.popupDropdownSelectedType = type;
    if (type === "condition") {
      this.popup.dropdownOptions = [...this.conditionsList];
    } else if (type === "action") {
      this.popup.dropdownOptions = [...this.actionsList];
    }
    this.popup.mode = "dropdown";
  }

  async onPopupSelect(id: number, actionType: string, option: any) {
    if (actionType === "action") {
      this.setActionValidation();
      if (option?.type === "email") {
        await this.getEmailTemplateLists(option?.type);
      } else if (option?.type === "campaign_stop") {
        this.actionType = option?.type || "";
        this.routeOption = actionType;
        this.modalTitle = option?.name;
        this.popupSelectedOptionId = option?.id;
        this.createTerminationNode();
        return;
      } else if (option?.type === "social post") {
        await this.getSocialPostTemplateList(option?.type);
        this.getSocialPostMediaTypeList();
      } else {
        await this.getAllTemplate(option?.type);
      }
    } else if (actionType === "condition") {
      this.setConditionValidation();
      this.availableFields = await this.getConditionFieldsByID(option?.id);
    }

    this.isEditMode = false; // reset flag
    const node = this.nodes.find((n) => n.id === id);
    this.actionType = option?.type || "";
    this.popupSelectedOptionId = option?.id || null;
    if (node) {
      this.editNodeId = id;
    }
    this.nodeForm.reset({
      toSendType: "transactional",
      executionData: { type: "", value: "" },
    });
    this.routeOption = actionType;
    this.ngbModal.open(this.routeConditionModal, {
      size: "lg",
      backdrop: true,
    });
    this.modalTitle = option?.name;
    this.modalLabel = option?.label || "";    
    this.popup.visible = false;
    this.popup.mode = "cards";
  }

  onFieldChange() {    
    const selectedFieldId = this.nodeForm.get('condition.field')?.value;
    const selectedField = this.availableFields.find(
      (f) => f.id === selectedFieldId,
    );
    
    this.modalLabel = selectedField?.label || "";
    this.selectedFieldDesc = selectedField?.desc || "";
  }
  setActionValidation() {
    this.nodeForm.get('actionValue')?.setValidators([Validators.required]);

    this.nodeForm.get('condition.field')?.clearValidators();
    this.nodeForm.get('condition.operator')?.clearValidators();
    this.nodeForm.get('condition.value')?.clearValidators();

    this.updateConditionValidity();
  }

  setConditionValidation() {
    this.nodeForm.get('actionValue')?.clearValidators();

    this.nodeForm.get('condition.field')?.setValidators([Validators.required]);
    this.nodeForm.get('condition.operator')?.setValidators([Validators.required]);
    this.nodeForm.get('condition.value')?.setValidators([Validators.required]);

    this.updateConditionValidity();
  }

  updateConditionValidity() {
    this.nodeForm.get('actionValue')?.updateValueAndValidity();
    this.nodeForm.get('condition.field')?.updateValueAndValidity();
    this.nodeForm.get('condition.operator')?.updateValueAndValidity();
    this.nodeForm.get('condition.value')?.updateValueAndValidity();
  }


  backToPopupCards() {
    this.popup.mode = "cards";
    this.popup.selectedOption = "";
  }

  async onEdit(id: number) {
    const node = this.nodes.find((n) => n.id === id);
    if (node) {
      console.log("Editing node:", node);
      this.isEditMode = true;
      this.editNodeId = node.id;
      this.routeOption = node.node_type;
      this.popupSelectedOptionId = node.selected_node_type_id || null;
      this.editLabel = node.node_form_data?.["name"] || "";

      // Reset form and clear conditions first
      this.nodeForm.reset({
        toSendType: "transactional",
        executionData: { type: "", value: "" },
      });

      // Detect node type
      const isCondition = node.node_type === "condition";
      const isAction = node.node_type === "action";

      // ---- Condition Node ----
      if (isCondition) {
        this.setConditionValidation();
        const isFormCondition = node.node_form_data?.condition;
        this.availableFields = await this.getConditionFieldsByID(
          this.popupSelectedOptionId,
        );
        this.selectedField =
          this.availableFields.find(
            (f) => f.id === isFormCondition.field?.id,
          ) || null;
        this.selectedFieldValueType = node.node_form_data?.table_field_type;
        const condition = node.node_form_data?.["condition"] || [];
        this.nodeForm.patchValue({
          condition: {
            field: condition.field?.id || "",
            operator: condition.operator || "",
            value: condition.value || "",
          },
          executionData: node.node_form_data?.["executionData"] || {
            type: "",
            value: "",
          },
        });
        this.selectedFieldDesc = condition.field.desc || "";
        this.activeButton = node.node_form_data?.["activeButton"] || "";
      }

      // ---- Action Node ----
      if (isAction) {
        this.setActionValidation();
        const option = node.node_form_data?.["template"] || {};

        if (option?.type === "email") {
          await this.getEmailTemplateLists(option?.type);
        } else if (option?.type === "social post") {
          await this.getSocialPostTemplateList(option?.type);
          this.getSocialPostMediaTypeList();
        } else {
          await this.getAllTemplate(option?.type);
        }

        this.actionType = option?.type || "";
        // Patch action-related fields into form
        this.nodeForm.patchValue({
          actionValue: this.filterSelectedTemplateFromTemplateList(option?.id),
          toSendType: node.node_form_data?.["to_send_type"] || "transactional",
          executionData: node.node_form_data?.["executionData"] || {
            type: "",
            value: "",
          },
        });

        this.activeButton = node.node_form_data?.["activeButton"] || "";
      }

      // Common data for both types
      this.modalTitle = node.node_form_data?.["title"] || "";
      this.modalLabel = node.node_form_data?.["label"] || this.modalTitle;

      // Patch name field (used as label)
      this.nodeForm.patchValue({
        name: node.node_form_data?.["name"] || "",
      });

      this.ngbModal.open(this.routeConditionModal, {
        size: "lg",
        backdrop: true,
      });
      this.popup.visible = false;
      this.popup.mode = "cards";
    }
  }

  onCancel(id: number) {
    const nodeId = "flowchartWindow" + id;
    const element = document.getElementById(nodeId);
    if (element) {
      this.instance._removeElement(element as HTMLElement);
      this.instance.removeAllEndpoints(element as HTMLElement);
    }

    this.nodes = this.nodes.filter((node: any) => node.id !== id);
    const idStr = id.toString();
    this.connections = this.connections.filter(
      (conn: any) => conn.sourceId !== idStr && conn.targetId !== idStr,
    );

    if (this.nodes.length === 0) {
      // Reset state variables
      this.nodes = [];
      this.connections = [];
      // this.nextNodeId = 1;
      this.startFlow = false; // hide canvas container if using *ngIf
      this.onStart();
    }
  }

  onBottomPlus(
    nodeId: number,
    event: MouseEvent,
    originAnchor: "bottom" | "bottomLeft" | "bottomRight" = "bottom",
  ) {
    const canvas = document.getElementById("canvas");
    const target = event.target as HTMLElement;

    if (!canvas || !target) return;

    const canvasRect = canvas.getBoundingClientRect();

    const popupWidth = 650;
    const popupHeight = 150;
    const padding = 10;

    const clickX = event.clientX;
    const clickY = event.clientY;

    // 2. Calculate initial position relative to canvas
    let left = clickX - canvasRect.left;
    let top = clickY - canvasRect.top;

    // 3. Adjust left if it would overflow to the right
    if (left + popupWidth > canvasRect.width) {
      left = canvasRect.width - popupWidth - padding;
    }

    // 4. Adjust top if it would overflow to the bottom
    if (top + popupHeight > canvasRect.height) {
      top = canvasRect.height - popupHeight - padding;
    }

    // 5. Clamp to top/left boundaries (optional)
    if (left < padding) left = padding;
    if (top < padding) top = padding;

    // Final popup object
    this.popup = {
      visible: true,
      top: top,
      left: left,
      items: [
        {
          title: "Action",
          description:
            "An action is something executed by Mautic (e.g. send an email).",
          type: "action",
          color: "#02ad88",
        },
        {
          title: "Condition",
          description:
            "A condition is based on known profile field values or submitted form data.",
          type: "condition",
          color: "#f86b4f",
        },
      ],
      dropdownOptions: [],
      selectedOption: "",
      nodeId,
      origin: originAnchor,
      mode: "cards",
    };
  }

  createTerminationNode() {
    const newId = this.getNextNodeId();
    const newNode = {
      id: newId,
      // label: this.modalTitle,
      label: 'Exit',
      top: this.popup.top + 50,
      left: this.popup.left,
      color: "#ff0000", // Red
      bgColor: "#fcdada", // soft light red
      selected_node_type_id: this.popupSelectedOptionId,
      sourceAnchors: [],
      targetAnchors: [AnchorLocations.Top],
      node_type: this.routeOption,
    };
    this.onPopupAction(newId, newNode, "Create Termination Method");
  }

  createOrUpdateNode() {
    if (this.nodeForm.invalid) {
      this.nodeForm.markAllAsTouched();
      return;
    }

    const formValue = this.nodeForm.value;
    const isCondition = this.routeOption === "condition";
    const isAction = this.routeOption === "action";

    if (this.isEditMode) {
      // EDIT MODE → update data only
      const node = this.nodes.find((n: any) => n.id === this.editNodeId);
      if (node) {
        node.label =
          formValue.name && formValue.name.trim() !== ""
            ? formValue.name : this.modalTitle;
        node.node_type = this.routeOption;
        node.color = this.getNodeBorderColor(this.routeOption);
        node.bgColor = this.getNodeBackgroundColor(this.routeOption);
        node.selected_node_type_id = this.popupSelectedOptionId;

        const selectedField = this.availableFields.find(
          (f) => f.id === formValue.condition.field,
        );

        node.node_form_data = {
          ...(isCondition && {
            condition: {
              field: {
                id: selectedField?.id || "",
                name: selectedField?.name || "",
                tabel_name: selectedField?.table_name || "",
                label: selectedField?.label || "",
                desc: selectedField?.desc || "",
              },
              operator: formValue.condition?.operator,
              value: formValue.condition?.value,
              table_field_type: selectedField?.table_field_type || "",
            },
            ...(this.activeButton === "immediately" || this.activeButton === "till-event-date"
              ? { activeButton: this.activeButton }
              : {
                  activeButton: this.activeButton,
                  executionData: formValue.executionData,
                }),
          }),
          ...(isAction && {
            template: {
              id: formValue.actionValue?.id || "",
              name: formValue.actionValue?.name || "",
              type: formValue.actionValue?.type || "",
            },
            to_send_type: formValue.toSendType,
            ...(this.activeButton === "immediately" || this.activeButton === "till-event-date"
              ? { activeButton: this.activeButton }
              : {
                  activeButton: this.activeButton,
                  executionData: formValue.executionData,
                }),
          }),
          title: this.modalTitle,
          label: this.modalLabel,
          name: formValue.name?.trim(),
        };

        const allConnections =
          this.instance.getConnections() as unknown as Connection[];
        const connections = (allConnections || []).filter(
          (conn) => conn.targetId === "flowchartWindow" + node.id.toString(),
        );

        this.updateNodeOverlayLabel(node, connections);
      }
      this.popup.visible = false;
      this.ngbModal.dismissAll(); // Close the modal
      this.isEditMode = false; // reset flag
      this.cleanFormDataAfterNodeCreation();
    } else {
      // CREATE MODE → add new node
      const newId = this.getNextNodeId();

      const selectedField = this.availableFields.find(
        (f) => f.id === formValue.condition.field,
      );
      const newNode = {
        id: newId,
        // label: isCondition ? `Condition Node ${newId}` : this.editLabel,
        label: formValue.name && formValue.name.trim() !== ""
            ? formValue.name : this.modalTitle,
        top: this.popup.top + 50,
        left: this.popup.left,
        color: this.getNodeBorderColor(this.routeOption),
        bgColor: this.getNodeBackgroundColor(this.routeOption),
        selected_node_type_id: this.popupSelectedOptionId,
        sourceAnchors: isCondition
          ? [AnchorLocations.BottomLeft, AnchorLocations.BottomRight]
          : [AnchorLocations.Bottom],
        targetAnchors: [AnchorLocations.Top],
        node_type: this.routeOption,
        node_form_data: {
          ...(isCondition && {
            condition: {
              field: {
                id: selectedField?.id || "",
                name: selectedField?.name || "",
                tabel_name: selectedField?.table_name || "",
                label: selectedField?.label || "",
                desc: selectedField?.desc || "",
              },
              operator: formValue.condition?.operator,
              value: formValue.condition?.value,
              table_field_type: selectedField?.table_field_type || "",
            },
            ...(this.activeButton === "immediately" || this.activeButton === "till-event-date"
              ? { activeButton: this.activeButton }
              : {
                  activeButton: this.activeButton,
                  executionData: formValue.executionData,
                }),
          }),
          ...(isAction && {
            template: {
              id: formValue.actionValue?.id || "",
              name: formValue.actionValue?.name || "",
              type: formValue.actionValue?.type || "",
            },
            to_send_type: formValue.toSendType,
            ...(this.activeButton === "immediately" || this.activeButton === "till-event-date"
              ? { activeButton: this.activeButton }
              : {
                  activeButton: this.activeButton,
                  executionData: formValue.executionData,
                }),
          }),
          title: this.modalTitle,
          label: this.modalLabel,
          name: formValue.name?.trim(),
        },
      };
      console.log("Creating new node:", newNode);
      this.onPopupAction(newId, newNode, "Create & Edit Method");
    }
  }


  updateNodeOverlayLabel(node: any, connections: Connection<any>[]){
    if (node.node_form_data?.executionData) {
      // Update overlay label if executionData changed
      let customLabel = ``;
      let value = node.node_form_data?.executionData.value;
      let type = node.node_form_data?.executionData.type;
      if (type === "dateTime") {
        customLabel = "wait until " + `${value}`;
      } else {
        const plural = value === 1 ? type.replace(/s$/, "") : type;
        const executionLabel = node.node_form_data?.activeButton === "await-time-period" ? "Wait" : "Wait Until Time";
        customLabel = `${executionLabel} (${value}  ${plural})`;
      }

      (connections || []).forEach((conn) => {
        const overlay = conn.getOverlay<LabelOverlay>(`overlay-${node.id}`);
        if (overlay) {
          overlay.setLabel(`${customLabel}`);
        } else {
          conn.addOverlay({
            type: "Label",
            options: {
              id: `overlay-${node.id}`,
              label: `${customLabel}`,
              location: 0.5,
              cssClass: "custom-overlay",
            },
          });
          this.instance.repaintEverything();
        }
      });
    } else {
      // Node has no executionData → remove overlay if exists
      (connections || []).forEach((conn) => {
        const overlayId = `overlay-${node.id}`;
        const overlay = conn.getOverlay(overlayId);
        if (overlay) {
          conn.removeOverlay(overlayId);
        }
      });
    }
  }

  onPopupAction(newId: any, newNode: any, source?: any) {
    this.nodes.push(newNode);

    setTimeout(() => {
      const newElement = document.getElementById("flowchartWindow" + newId);

      if (newElement) {
        const nodeKey = "Window" + newNode.id.toString();
        this._addEndpoints(
          nodeKey,
          newNode.sourceAnchors,
          newNode.targetAnchors,
        );

        if (this.popup.nodeId !== null) {
          const originAnchor =
            this.popup.origin[0].toUpperCase() + this.popup.origin.slice(1);

          const connection: any = {
            sourceId: this.popup.nodeId.toString(),
            sourceAnchor: originAnchor,
            targetId: newId.toString(),
            toAnchor: AnchorLocations.Top,
          };


          if (this.popup.origin != "bottom") {
            connection["branch"] =
              this.popup.origin === "bottomLeft" ? "Yes" : "No";
          }
          this.connections.push(connection);

          const fromUUID = `Window${this.popup.nodeId}${originAnchor}`;
          const toUUID = `Window${newId}Top`;

          const connectionOptions: any = {
            uuids: [fromUUID, toUUID],
            paintStyle: {
              strokeWidth: 2,
              stroke: this.getConnectorColor(this.routeOption),
              joinstyle: "round",
              outlineStroke: "white",
              outlineWidth: 2,
            },
          };

          if (newNode.node_form_data?.executionData) {
            let customLabel = ``;
            let value = newNode.node_form_data?.executionData.value;
            let type = newNode.node_form_data?.executionData.type;
            if (type === "dateTime") {
              customLabel = "wait until " + `${value}`;
            } else {
              const plural = value === 1 ? type.replace(/s$/, "") : type;
              const executionLabel = newNode.node_form_data?.activeButton === "await-time-period" ? "Wait" : "Wait Until Time";
              customLabel = `${executionLabel} (${value}  ${plural})`;
            }
            connectionOptions.overlays = [
              {
                type: "Label",
                options: {
                  label: `${customLabel}`,
                  location: 0.5,
                  id: `overlay-${newId}`,
                  cssClass: "custom-overlay",
                },
              },
            ];
          }

          this.instance.connect(connectionOptions);

          if (this.nodes.length === 1) {
            this._initJsPlumbWithFlowData();
          }
        }
      }
    }, 0);

    // Hide the popup
    this.popup.visible = false;
    this.ngbModal.dismissAll(); // Close the modal
    this.cleanFormDataAfterNodeCreation();
  }

  previewEmailWindow(data) {
    const previewHtml = data.html;
    if (previewHtml) {
      const width = window.screen.width / 2;
      const height = window.screen.height / 2;
      const left = window.screen.width / 4;
      const top = window.screen.height / 4;

      const newWin = window.open(
        "",
        "TemplatePreview",
        `width=${width},height=${height},left=${left},top=${top},resizable,scrollbars`,
      );
      if (newWin) {
        newWin.document.open();
        newWin.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Template Preview</title>
          <meta charset="UTF-8" />
        </head>
        <body>
          ${previewHtml}
        </body>
      </html>
    `);
        newWin.document.close();
      }
    }
  }

  cleanFormDataAfterNodeCreation() {
    this.editLabel = "";
    this.actionValue = null;
    this.activeButton = "immediately";
    this.executionData = { type: "", value: "1" };
    this.isEditMode = false;
    this.editNodeId = null;
    this.routeOption = "";
    this.modalTitle = "";
    this.popup.selectedOption = "";
    this.modalLabel = "";
    this.selectedFieldDesc = "";
    this.nodeForm.reset();

    if (this.nodes.length === 0) {
      this.onStart();
    }
  }

  onConfirmDropdown() {
    alert(
      `Confirmed option: ${this.popup.selectedOption} for node ${this.popup.nodeId}`,
    );
    this.popup.visible = false;
  }

  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;

    const clickedInside =
      target.closest(".popup-card-container") ||
      target.closest(".svg-anchor") ||
      target.tagName.toLowerCase() === "select" ||
      target.closest("select");

    if (!clickedInside) {
      if (this.nodes.length > 0) {
        this.popup.visible = false;
      }
    }
  }

  onTimeDatePeriodClick(buttonType: string) {
    this.activeButton = buttonType;
    if (buttonType === "await-time-period" || buttonType === "till-time-period") {
      this.nodeForm.get("executionData")?.patchValue({
        value: 1,
        type: "minutes",
      });
    } else if (buttonType === "date-time") {
      const today = new Date();
      const formattedDate = today.toISOString().split("T")[0];
      this.nodeForm.get("executionData")?.patchValue({
        value: formattedDate,
        type: "dateTime",
      });
    }
  }

  onSelectConditionField(fieldId: any) {
    this.selectedField = this.availableFields.find((f) => f.id === fieldId) || {
      id: "",
      name: "",
      table_name: "",
      table_field_operator_list: [],
      table_field_option_values: [],
      table_field_type: "",
    };

    this.availableOperators = this.selectedField?.table_field_operator_list;
    this.selectedFieldValueType = this.selectedField?.table_field_type;
    this.selectedFieldValueList = [];
  }

  onSelectConditionFieldOperator(selectedField: any) {
    this.selectedFieldValueList = selectedField?.table_field_option_values;
  }

  submit() {
    this.submitted = true;
    if (this.journeyflowForm.valid) {
      this.journeyflowForm.markAllAsTouched();
      this.saveFlowToJson();
    }
  }

  saveFlowToJson() {
    this.ngxSpinnerService.show();
    const nodes: FlowNode[] = [];
    const connections: any = [];
    const journey_id = this.journeyflowForm.get("journeyTypeID").value;
    const theme_id = this.journeyflowForm.get("themeID").value;
    const journey_flow_name = this.journeyflowForm.get("journeyflowName").value;

    nodes.push(...this.nodes);
    connections.push(...this.connections);

    const flowchartJson: FlowchartJSON = { nodes, connections };
    const finalJson = {
      companyID: this.companyID,
      journeyID: journey_id,
      themeID: theme_id,
      flowchart: flowchartJson,
    };
    let payload: any = {
      cjb_name: journey_flow_name,
      cjb_json: finalJson,
      company_id: this.companyID,
      journey_id: Number(journey_id),
      theme_id: Number(theme_id),
      is_product: this.hasProductVal,
    };
    if (this.editJourneyId) {
      payload["id"] = this.editJourneyId;
    }
    this.clientService
      .saveJourneyBuilderData(this.companyID, payload)
      .subscribe(
        (res) => {
          if (res.status) {
            if (res?.insertId) this.editJourneyId = res?.insertId;
            this.ngxSpinnerService.hide();
            this.toastrService.success(res.message);
          } else {
            this.ngxSpinnerService.hide();
          }
          this.submitted = false;
        },
        (error) => {
          console.log(error);
          this.ngxSpinnerService.hide();
          this.toastrService.error(
            "Something went wrong while saving journey builder.",
          );
          this.submitted = false;
        },
      );
  }

  getNodeBorderColor(type: string) {
    if (type == "action") {
      return "#78b984";
    } else {
      return "#f86b4f";
    }
  }

  getNodeBackgroundColor(type: string) {
    if (type == "action") {
      return "#d0eed6";
    } else {
      return "#ffeecf";
    }
  }

  getConnectorColor(nodeType: string): string {
    return nodeType === "condition" ? "#F86B4F" : "#00B49C";
  }

  compareById = (option: any, value: any): boolean => {
    return option && value ? option.id === value.id : option === value;
  };


  autoArrange() {

    this.instance.batch(() => {
      const connections = this.connections;
      const graph: any = {};
      const parents: any = {};
      const connectionType: any = {};
      const nodes = new Set<string>();

      connections.forEach((conn: any) => {

        const s = conn.sourceId;
        const t = conn.targetId;

        nodes.add(s);
        nodes.add(t);

        if (!graph[s]) graph[s] = [];
        graph[s].push(t);

        parents[t] = s;

        // store connection type
        connectionType[t] = conn.sourceAnchor; // BottomLeft / BottomRight / Bottom

      });

      // find root
      const root = [...nodes].find(n => !parents[n]);

      const levels: any = {};
      const queue: any[] = [];

      levels[root!] = 0;
      queue.push(root);


      const visited = new Set();

      while (queue.length) {

        const node = queue.shift();

        if (visited.has(node)) continue;

        visited.add(node);

        const level = levels[node];

        (graph[node] || []).forEach((child: any) => {

          if (levels[child] === undefined) {
            levels[child] = level + 1;
          }

          if (!visited.has(child)) {
            queue.push(child);
          }

        });

      }

      const levelMap: any = {};

      Object.keys(levels).forEach(node => {

        const lvl = levels[node];

        if (!levelMap[lvl]) levelMap[lvl] = [];
        levelMap[lvl].push(node);

      });

      const xSpacing = 250;
      const ySpacing = 150;

      const nodePositions: any = {};

      const levelUsedX: any = {};   // track used X per level
      

      Object.keys(levelMap).forEach((lvl: any) => {

        const level = Number(lvl);

        if (!levelUsedX[level]) {
          levelUsedX[level] = [];
        }

        levelMap[lvl].forEach((nodeId: string, index: number) => {

          let x: any;

          const parent = parents[nodeId];

          if (parent && nodePositions[parent] !== undefined) {

            const siblings = graph[parent] || [];
            const parentX = nodePositions[parent];
            const type = connectionType[nodeId];

            if (type === "BottomLeft") {

              x = parentX - xSpacing;

            }
            else if (type === "BottomRight") {

              x = parentX + xSpacing;

            }
            else if (type === "Bottom") {

              x = parentX;

            }
            else {

              // center siblings under parent
              const offset = (index - (siblings.length - 1) / 2) * xSpacing;
              x = parentX + offset;

            }

          } else {

            // root node
            x = 600;

          }

          // 🔥 collision detection (main improvement)
          while (levelUsedX[level].some((usedX: number) => Math.abs(usedX - x) < xSpacing)) {
            x += xSpacing;
          }

          levelUsedX[level].push(x);

          const y = level === 0 ? 20 : level * ySpacing;

          nodePositions[nodeId] = x;

          const el = document.getElementById("flowchartWindow" + nodeId);

          if (el) {

            el.style.left = x + "px";
            el.style.top = y + "px";

            this.instance.setPosition(el, { x: x, y: y });

            this.updateNodePosition(Number(nodeId), x, y);

          }

        });

      });


      // 🔥 LEFT CUT FIX
      const allX: number[] = Object.values(nodePositions);
      const minX = Math.min(...allX);

      if (minX < 100) {

        const shift = Math.abs(minX) + 150;

        Object.keys(nodePositions).forEach((nodeId: any) => {

          const newX = nodePositions[nodeId] + shift;

          const el = document.getElementById("flowchartWindow" + nodeId);

          if (el) {

            const y = el.offsetTop;

            el.style.left = newX + "px";

            this.instance.setPosition(el, { x: newX, y: y });

            this.updateNodePosition(Number(nodeId), newX, y);

          }

        });

      }

    });

  }

  updateNodePosition(nodeId: number, x: number, y: number) {
    const node = this.nodes.find((n: any) => n.id === nodeId);
    if (!node) return;
    node.left = x;
    node.top = y;
  }

  getNextNodeId() {
    return Math.max(...this.nodes.map((n: any) => n.id), 0) + 1;
  }
  @HostListener('window:resize')
  checkScreen() {
    this.isMobile = window.innerWidth <= 768;
  }

  updateBtn() {
    if (this.isMobile) {
      this.isOpen = !this.isOpen;
    }
  }

}
